import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { toSignal } from "@angular/core/rxjs-interop";
import { PrintKioskActions, PrintKiosksSelectors } from "@core/state/print-kiosks";
import { CreatePrintKioskDeviceCommand, CreateDeviceRelationshipCommand } from "@shared/models/commands";

@Injectable({ providedIn: "root" })
export class PrintKiosksFacade {
  private readonly _store = inject(Store);

  readonly allPrintKiosks = toSignal(this._store.select(PrintKiosksSelectors.all), { initialValue: [] });
  readonly isLoading = toSignal(this._store.select(PrintKiosksSelectors.isLoading), { initialValue: false });
  readonly error = toSignal(this._store.select(PrintKiosksSelectors.error), { initialValue: null });

  load(): void {
    this._store.dispatch(PrintKioskActions.load());
  }

  add(command: CreatePrintKioskDeviceCommand): void {
    this._store.dispatch(PrintKioskActions.add({ command }));
  }

  remove(id: string): void {
    this._store.dispatch(PrintKioskActions.remove({ command: { id } }));
  }

  linkToPrinter(command: CreateDeviceRelationshipCommand): void {
    this._store.dispatch(PrintKioskActions.linkToPrinter({ command }));
  }
}
